export const environment = {
  production: true,
  HOST: "https://bluehill.hu",
  API_PATH_PREFIX: "/api/v1/",
  API_RETRY: 2,
  AUTHZ_PERMISSION_NAME: "eventandbooking.update",
  BRANDING_LOGO: "storage/bluehill_logo_white.png",
  SENTRY_DSN: "https://a97c45706aa24137b6a341f0a21b0939@o251613.ingest.sentry.io/4504085806645248",
  SCANNER_READ_LOCK_SECONDS: 3000,
  AUTO_SYNC_INTERVAL: 150000,
  DEFAULT_EVENTS: [200, 206],
  DEFAULT_RETAILER_ID: 13,
  DEFAULT_CUSTOMER_EMAIL: "on-site-sale@bluehill.hu"
};
